import {ProductOptionValueItemType} from "../../definitions/types";

export class ProductOptionValueItemModel {
    private readonly _optionItemValue: ProductOptionValueItemType;

    /**
     * @constructor
     * @param optionValueItem {ProductOptionValueItemType}
     * @description Creates a new instance of the ProductOptionValueItemModel class.
     */
    constructor(public readonly optionValueItem: ProductOptionValueItemType) {
        this._optionItemValue = optionValueItem;
    }

    /**
     * @method id
     * @description Returns the ID of the value item for the option.
     * @returns {number}
     */
    public get productId(): number {
        return this._optionItemValue.productId;
    }

    /**
     * @method sku
     * @description Returns the SKU of the value item for the option.
     * @returns {string}
     */
    public get sku(): string {
        return this._optionItemValue.sku;
    }

    /**
     * @method title
     * @description Returns the title of the value item for the option.
     * @returns {string}
     */
    public get title(): string {
        return this._optionItemValue.title;
    }

    /**
     * @property primaryId
     * @description Returns the primary ID of the value item for the option.
     * @returns {number | undefined}
     */
    public get primaryId(): number | undefined {
        return this._optionItemValue.primaryId;
    }

    /**
     * @property path
     * @description Returns the path of the value item for the option.
     * @returns {string}
     */
    public get path(): string {
        return this._optionItemValue.path;
    }
}